<template>
  <div class="icd10Search">
    <v-text-field
      :id="inputId"
      :model-value="modelValue"
      :data-test="dataTest"
      v-bind="$attrs"
      hide-details
      @update:model-value="onInput"
      @focus="onFocusIcd10Search(true)"
      @blur="onFocusIcd10Search(false)"
    />
    <div
      v-if="icd10SearchFocus"
      class="icd10ResultField"
    >
      <div :class="{ icd10ListWrap: icd10SearchResults.length !== 0 }">
        <div class="icd10ListArea">
          <div
            v-for="result in icd10SearchResults"
            :key="result.id"
          >
            <p @click="onSelectDiagnosis(result)">
              <a>{{ result.name }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

/**
 * ICD10（暫定診断）キーワード検索入力フィールド（FSD shared/ui）
 *
 * v-model でキーワード文字列を受け取り、入力に応じて
 * /api/v1/icd10/all_types/search へリクエストしてサジェストを表示する。
 *
 * 使用例:
 *   <Icd10KeywordInput v-model="icd10Keyword" />
 */
export default {
  name: "Icd10KeywordInput",

  inheritAttrs: false,

  props: {
    modelValue: {
      type: String,
      default: ""
    },
    /** テキストフィールドの id 属性（デフォルト: "icd10SearchField"） */
    inputId: {
      type: String,
      default: "icd10SearchField"
    },
    /** data-test 属性（デフォルト: "icd10Keyword-field"） */
    dataTest: {
      type: String,
      default: "icd10Keyword-field"
    }
  },

  emits: ["update:modelValue"],

  data() {
    return {
      icd10SearchFocus: false,
      icd10SearchResults: []
    };
  },

  methods: {
    onInput(value) {
      this.$emit("update:modelValue", value);
      this.searchIcd10(value);
    },

    searchIcd10(keyword) {
      axios
        .get("/api/v1/icd10/all_types/search", {
          params: { keyword }
        })
        .then(res => {
          this.icd10SearchResults = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },

    onSelectDiagnosis(result) {
      this.$emit("update:modelValue", result.name);
      this.icd10SearchResults = [];
    },

    onFocusIcd10Search(flag) {
      // サジェスト候補クリック時にフォーカスが外れる前に onSelectDiagnosis が
      // 発火するよう、少し遅延してフラグを切り替える。
      setTimeout(() => {
        this.icd10SearchFocus = flag;
      }, 300);
    }
  }
};
</script>
